import { render, staticRenderFns } from "./TheModalMasiveCreation.vue?vue&type=template&id=9921cc04&scoped=true"
import script from "./TheModalMasiveCreation.vue?vue&type=script&lang=js"
export * from "./TheModalMasiveCreation.vue?vue&type=script&lang=js"
import style0 from "./TheModalMasiveCreation.vue?vue&type=style&index=0&id=9921cc04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9921cc04",
  null
  
)

export default component.exports